module.exports = __webpack_public_path__ + "img/re-en_US-img2.4a95c3c7.png";